import { render } from "./Project_Description.vue?vue&type=template&id=c1986e48&scoped=true"
import script from "./Project_Description.vue?vue&type=script&lang=js"
export * from "./Project_Description.vue?vue&type=script&lang=js"

import "./Project_Description.vue?vue&type=style&index=0&id=c1986e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1986e48"]])

export default __exports__